module.exports = {"Description":"8-Digits - NNNNNNNN","RedundantCharacters":" -","ValidationRegex":"^[0-9]{8}$","TestData":{"Valid":["12345678","56785678"],"Invalid":["123345456","123s33s","1s23x3"]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/postal-codes-js/formats/8Digits.json
// module id = 4441
// module chunks = 11